export default __webpack_public_path__ + "static/media/Plus.8f983f3f.svg";